<template>
  <div class="relative">
    <!-- Cart Button -->
    <button class="relative p-2 text-gray-400 hover:text-primary transition-colors rounded-lg hover:bg-primary/10"
            aria-label="Shopping cart"
            @click="toggleCart">
      <!--<i class="fas fa-shopping-cart text-xl"></i>-->
      <font-awesome-icon :icon="['fal', 'shopping-cart']"
                         class="text-2xl" />

      <!-- Item Count Badge -->
      <span v-if="cartStore.itemCount > 0"
            class="absolute top-0 right-0 flex items-center justify-center w-5 h-5 bg-accent text-primary-foreground text-xs font-bold rounded-full">
        {{ cartStore.itemCount > 99 ? '99+' : cartStore.itemCount }}
      </span>
    </button>

    <!-- Floating Cart Component -->
    <ShoppingCartFloating :is-open="isOpen"
                          @close="closeCart" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useCartStore } from '@/stores/cartStore';
import ShoppingCartFloating from '@/components/cart/ShoppingCartFloating.vue';

const cartStore = useCartStore();
const isOpen = ref(false);

const toggleCart = () => {
  isOpen.value = !isOpen.value;
};

const closeCart = () => {
  isOpen.value = false;
};
</script>
